module.exports = __webpack_public_path__ + "img/speaker-one.65b5fdf4.png";